export default {
  fromValue (val) {
    switch (val) {
      case 'single':
        return 'Solteiro'
      case 'married':
        return 'Casado'
      case 'divorced':
        return 'Divorciado'
      case 'widowed':
        return 'Viúvo'
      case 'separated':
        return 'Separado'
      default:
        return val
    }
  }
}
